








































import { questionTypeToggles } from '@/utils/add-question/add-question-constant';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Toggle from '@/components/common/Toggle.vue';

@Component({
  components: {
    Toggle,
  },
})
export default class BuildQuestionInfo extends Vue {
  @Prop()
  questionId!: number;

  @Prop()
  isSubjective!: boolean;

  questionTypeToggles = questionTypeToggles;

  idInput = this.questionId || 0;

  get initialQuestionTypeToggle() {
    return questionTypeToggles.findIndex(type => {
      return type.id === this.isSubjective;
    });
  }

  updateQuestionId() {
    this.$emit('updateQuestionId', this.idInput);
  }

  updateIsSubjective(index: number) {
    const selectedQuestionType = this.questionTypeToggles[index];
    this.$emit('updateIsSubjective', selectedQuestionType.id);
  }

  previewQuestion() {
    this.$emit('previewQuestion');
  }

  @Watch('isSubjective')
  changeQuestion() {
    this.$emit('updateQuestionId', this.idInput);
  }
}
